import { useTranslation, Trans } from 'react-i18next'
import InlineBanner from '@/components/inline-banner'
import { ContentWrapper } from './elements'

const PaymentStatus = ({ paymentData, padActive }) => {
  const { t } = useTranslation()
  const errorMessage = paymentData.error_message
  const errorText =
    paymentData?.error_side === 'tenant' ? (
      t(
        'l.pad_payments.view.tenant_error.text',
        `We couldn't process payment due to a tenant error. Please contact your tenant to check their banking information before the next recurring payment.`
      )
    ) : (
      <Trans
        t={t}
        key="l.pad_payments.landlord_error.text"
        i18nKey="l.pad_payments.landlord_error.text"
        values={{ errorMessage }}
      >
        The payment amount was received from the tenant but couldn't be processed because{' '}
        {{ errorMessage }}. The payment amount has been refunded back to the tenant. Please make
        sure your bank account information provided is correct before the next recurring payment. If
        this issues persists, please contact us at support@liv.rent to resolve this issue.
      </Trans>
    )

  const getStatus = () => {
    switch (paymentData.payment_status) {
      case 'upcoming':
        if (padActive) {
          return (
            <InlineBanner
              theme="blue"
              icon="info_blue2"
              space="fit"
              isShow={true}
              body={t(
                'l.listing.view.automatic_rent_payments.text',
                'Automatic rental payments have been set up for this listing.'
              )}
              contentAlign="flexStart"
              iconAlign="center"
            />
          )
        } else {
          return null
        }

      case 'fail':
        return (
          <InlineBanner
            theme="error"
            icon="warning_alert"
            space="fit"
            isShow={true}
            title={t('l.listing.view.payment_failed.text', 'Payment Failed!')}
            body={errorText}
            contentAlign="flexStart"
          />
        )
      case 'pending':
        return (
          <InlineBanner
            theme="warning"
            icon="warning_alert"
            space="fit"
            isShow={true}
            title={t('l.listing.view.payment_processed.text', 'Payment processed!')}
            body={t(
              'l.listing.view.total_amount_details.text',
              'Total amount will be deposited in your bank account within 5 business days.'
            )}
            contentAlign="flexStart"
          />
        )
      default:
        return null
    }
  }
  return <ContentWrapper>{getStatus()}</ContentWrapper>
}

export default PaymentStatus
